import { FormErrors } from 'redux-form';
import { ArmyListFormated, FormatError, VersionGame } from '@Models';

const validate = (values: FormatParams): FormErrors<FormatParams> => {
  const errors: FormErrors<FormatParams> = {};

  if (!values.date) {
    errors.date = 'format.form.date.error';
  }

  if (!values.game) {
    errors.game = 'format.form.game.error';
  }

  if (!values.source) {
    errors.source = 'format.form.source.error';
  }

  return errors;
};
export default validate;

export type FormatParams = {
  date: Date;
  game: VersionGame;
  source: string;
  formated: string;
  formatedArmyList: ArmyListFormated;
  errors: Array<FormatError>;
};
